import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguagePickerComponent } from './language-picker.component';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    exports: [
        LanguagePickerComponent
    ],
    providers: [],
    declarations: [
        LanguagePickerComponent
    ]
})
export class LanguagePickerModule {
}
